import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Styleguide',
  setup(__props) {

const showModal = ref<boolean>(false);

const dummySelectOptionsData: any = ['Value 1', 'Value 2', 'Value 3', 'Value 4'];

function selectChanged(value: string) {
    console.log('selectChanged', value);
}

return { __sfc: true,showModal, dummySelectOptionsData, selectChanged }
}

})